import { NEWS_SERVICE } from "@/services/news.service.js";

const state = {postNewsOutput: false, getNewsOutput: {}, putNewsOutput: false, deleteNewsByIdOutput: false, getNewsByIdOutput: {}, getNewsBySlugOutput: {}};

const actions = {
    //Service to create news
    postNews({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postNewsRequest');

        NEWS_SERVICE.postNews(input)
            .then(
                output => {
                    commit('postNewsSuccess', output);
                },
                error => {
                    commit('postNewsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated news
    getNews({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getNewsRequest');

        NEWS_SERVICE.getNews(queryParams)
            .then(
                output => {
                    commit('getNewsSuccess', output);
                },
                error => {
                    commit('getNewsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update categories
    putNews({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putNewsRequest');

        NEWS_SERVICE.putNews(input)
            .then(
                output => {
                    commit('putNewsSuccess', output);
                },
                error => {
                    commit('putNewsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove news
    deleteNewsById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteNewsByIdRequest');

        NEWS_SERVICE.deleteNewsById(id)
            .then(
                output => {
                    commit('deleteNewsByIdSuccess', output);
                },
                error => {
                    commit('deleteNewsByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get news details
    getNewsById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getNewsByIdRequest');

        NEWS_SERVICE.getNewsById(id)
            .then(
                output => {
                    commit('getNewsByIdSuccess', output);
                },
                error => {
                    commit('getNewsByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get news details
    getNewsBySlug({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getNewsBySlugRequest');

        NEWS_SERVICE.getNewsBySlug(queryParams)
            .then(
                output => {
                    commit('getNewsBySlugSuccess', output);
                },
                error => {
                    commit('getNewsBySlugFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postNews
    postNewsRequest(state) {
        state.postNewsOutput = null;
    },
    postNewsSuccess(state, output) {
        state.postNewsOutput = true;
    },
    postNewsFailure(state) {
        state.postNewsOutput = false;
    },

    //getNews
    getNewsRequest(state) {
    },
    getNewsSuccess(state, output) {
        state.getNewsOutput = output;
    },
    getNewsFailure(state) {
        state.getNewsOutput = false;
    },

    //putNews
    putNewsRequest(state) {
        state.putNewsOutput = null;
    },
    putNewsSuccess(state, output) {
        state.putNewsOutput = true;
    },
    putNewsFailure(state) {
        state.putNewsOutput = false;
    },

    //deleteNewsById
    deleteNewsByIdRequest(state) {
        state.deleteNewsByIdOutput = null;
    },
    deleteNewsByIdSuccess(state, output) {
        state.deleteNewsByIdOutput = true;
    },
    deleteNewsByIdFailure(state) {
        state.deleteNewsByIdOutput = false;
    },

    //getNewsById
    getNewsByIdRequest(state) {
    },
    getNewsByIdSuccess(state, output) {
        state.getNewsByIdOutput = output;
    },
    getNewsByIdFailure(state) {
        state.getNewsByIdOutput = false;
    },

    //getNewsBySlug
    getNewsBySlugRequest(state) {
    },
    getNewsBySlugSuccess(state, output) {
        state.getNewsBySlugOutput = output;
    },
    getNewsBySlugFailure(state) {
        state.getNewsBySlugOutput = false;
    },
};

export const news = {
    namespaced: true,
    state,
    actions,
    mutations
};